/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BeginPairingMobileDeviceResponse,
  IntercomIdentityResponse,
  PairMobileDeviceRequest,
  PairMobileDeviceResponse,
  RegisterMobilePushTokenRequest,
} from '../models/index';
import {
    BeginPairingMobileDeviceResponseFromJSON,
    BeginPairingMobileDeviceResponseToJSON,
    IntercomIdentityResponseFromJSON,
    IntercomIdentityResponseToJSON,
    PairMobileDeviceRequestFromJSON,
    PairMobileDeviceRequestToJSON,
    PairMobileDeviceResponseFromJSON,
    PairMobileDeviceResponseToJSON,
    RegisterMobilePushTokenRequestFromJSON,
    RegisterMobilePushTokenRequestToJSON,
} from '../models/index';

export interface PairMobileDeviceOperationRequest {
    pairMobileDeviceRequest?: PairMobileDeviceRequest;
}

export interface RegisterMobilePushTokenOperationRequest {
    registerMobilePushTokenRequest?: RegisterMobilePushTokenRequest;
}

/**
 * 
 */
export class MobileApi extends runtime.BaseAPI {

    /**
     * Creates a short-lived single-use pairing nonce for the signed-in user, to be rendered as a QR code. A signed-out mobile device scans it and exchanges it for a device token via /mobile/pair. The nonce snapshots the caller\'s identity; the paired device acts as this user. 
     * Begin Mobile Device Pairing
     */
    async beginPairingMobileDeviceRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BeginPairingMobileDeviceResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/begin-pairing`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BeginPairingMobileDeviceResponseFromJSON(jsonValue));
    }

    /**
     * Creates a short-lived single-use pairing nonce for the signed-in user, to be rendered as a QR code. A signed-out mobile device scans it and exchanges it for a device token via /mobile/pair. The nonce snapshots the caller\'s identity; the paired device acts as this user. 
     * Begin Mobile Device Pairing
     */
    async beginPairingMobileDevice(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BeginPairingMobileDeviceResponse> {
        const response = await this.beginPairingMobileDeviceRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns the HMAC-SHA256 of the signed-in user\'s id, signed with the Intercom identity verification secret. The mobile app passes this to the Intercom SDK so Intercom can prove the user is who they claim to be — without it, anyone could open a conversation as any user. The secret never leaves the backend. 
     * Get Intercom Identity Verification Hash
     */
    async getIntercomIdentityRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IntercomIdentityResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/intercom-identity`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IntercomIdentityResponseFromJSON(jsonValue));
    }

    /**
     * Returns the HMAC-SHA256 of the signed-in user\'s id, signed with the Intercom identity verification secret. The mobile app passes this to the Intercom SDK so Intercom can prove the user is who they claim to be — without it, anyone could open a conversation as any user. The secret never leaves the backend. 
     * Get Intercom Identity Verification Hash
     */
    async getIntercomIdentity(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IntercomIdentityResponse> {
        const response = await this.getIntercomIdentityRaw(initOverrides);
        return await response.value();
    }

    /**
     * Exchanges a scanned pairing nonce for a long-lived device token. Anonymous: the nonce is the credential. The nonce is consumed atomically (single use) and must be unexpired. The returned deviceToken is shown to the device exactly once; the device stores it and sends it as its bearer token thereafter. 
     * Pair Mobile Device
     */
    async pairMobileDeviceRaw(requestParameters: PairMobileDeviceOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PairMobileDeviceResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/mobile/pair`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PairMobileDeviceRequestToJSON(requestParameters['pairMobileDeviceRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PairMobileDeviceResponseFromJSON(jsonValue));
    }

    /**
     * Exchanges a scanned pairing nonce for a long-lived device token. Anonymous: the nonce is the credential. The nonce is consumed atomically (single use) and must be unexpired. The returned deviceToken is shown to the device exactly once; the device stores it and sends it as its bearer token thereafter. 
     * Pair Mobile Device
     */
    async pairMobileDevice(requestParameters: PairMobileDeviceOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PairMobileDeviceResponse> {
        const response = await this.pairMobileDeviceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Registers (or refreshes) this device\'s push token for the signed-in user, binding the device to that user and their company so the backend can send push notifications to it. Idempotent on the token — re-registering updates the existing record. 
     * Register Mobile Push Token
     */
    async registerMobilePushTokenRaw(requestParameters: RegisterMobilePushTokenOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("JWT", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/mobile/register-push-token`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterMobilePushTokenRequestToJSON(requestParameters['registerMobilePushTokenRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Registers (or refreshes) this device\'s push token for the signed-in user, binding the device to that user and their company so the backend can send push notifications to it. Idempotent on the token — re-registering updates the existing record. 
     * Register Mobile Push Token
     */
    async registerMobilePushToken(requestParameters: RegisterMobilePushTokenOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.registerMobilePushTokenRaw(requestParameters, initOverrides);
    }

}
